export default {"src":"/_next/static/media/number-sales.167d6d18.svg","height":34,"width":34};